export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">关于我们</h2>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
            <div className="prose prose-sm max-w-none">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                <strong className="text-foreground-900">青青草视频</strong> 是一个专注于影视大全与热门视频合集的内容聚合导航平台。
                我们致力于整合妖精视频、桃花视频、苹果视频、榴莲视频、豆花视频、菠萝视频、红杏视频等多家特色视频平台资源，
                为用户提供一站式的视频内容发现与浏览体验。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                自上线以来，青青草视频已覆盖超过<strong className="text-primary-600">50家</strong>优质视频平台，
                收录<strong className="text-primary-600">10万+</strong>精选视频资源，日均更新热门视频合集数百条。
                我们的人工编辑团队与智能推荐系统协同工作，确保每一条推荐都经过精心筛选。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                我们的使命是打造最全面、最便捷的影视大全与热门视频合集平台。无论您是在寻找妖精视频的最新好片、
                桃花视频的独家专题、苹果视频的高分推荐，还是榴莲视频的新片速递，
                青青草视频都能为您提供精准的内容索引与导航服务。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                青青草视频坚持<strong className="text-foreground-900">免费开放</strong>、<strong className="text-foreground-900">无广告干扰</strong>的运营理念，
                持续优化用户体验，拓展内容生态。欢迎更多优质视频平台与我们建立合作关系，
                共同为用户创造更加丰富的影视大全与热门视频合集浏览体验。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-6 text-center pt-6 border-t border-background-200/60">
              <div>
                <p className="text-2xl font-bold text-primary-600 font-heading">2024</p>
                <p className="text-xs text-foreground-500 mt-1">平台创立年份</p>
              </div>
              <div>
                <p className="text-2xl font-bold text-accent-600 font-heading">50+</p>
                <p className="text-xs text-foreground-500 mt-1">合作视频平台</p>
              </div>
              <div>
                <p className="text-2xl font-bold text-secondary-600 font-heading">500万+</p>
                <p className="text-xs text-foreground-500 mt-1">累计服务用户</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}